<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldCalculateComplexityPopup.vue'
import NewFooterView from './New/NewCalculateComplexityPopup.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
